<template>
  <div>
    <h4>{{project.name}}</h4>
    <hr>
    <Services :project-id="props.id"/>

  </div>
</template>

<script setup>
import {defineProps, computed} from 'vue'
const props  = defineProps({
  id: String,
})

import {useProjectStore} from '@/store/projects'
import Services from "@/views/services/Services";
const projectStore = useProjectStore()
const project = computed(() => projectStore.item)
projectStore.getById(props.id)
</script>
